// eslint-disable-next-line import/no-anonymous-default-export
export default async function (...args) {
  const response = await fetch(...args)
  return await response.json()
}
